import { Text, Button, useDisclosure } from "@chakra-ui/react"
import React from "react"
import ConfirmDialog from '../ConfirmDialog';

const Confirm=({style, title, enabled=true, icon=false, message, onClick, text})=> {
    
    const { isOpen, onOpen, onClose } = useDisclosure()


    const handleClick = ()=>{
      enabled && onOpen()
    }

    return (
      <>
<br></br>
        <Button style={style || {margin:'1rem 0rem', 'backgroundColor':"#f7931a","color":"white"}} onClick={handleClick}>

        {
          icon ?  (<i className={icon} />) :

            (<Text>{text}</Text>)
        }
        </Button>

         <ConfirmDialog
          isOpen={isOpen}
          onClose={onClose}
          title={title}
          message={message}
          handle={onClick} />

      </>
    )
  }

export default Confirm